<ngx-json-ld [json]="schema"></ngx-json-ld>
<div class="header">

  <div class="login-container">

    <span *ngIf="!isUserLoggedIn" class="header-item" (click)="loginClicked()">{{getString("login")}}</span>

    <div *ngIf="isUserLoggedIn" class="dropdown">
      <img alt="" class="profile-image" [src]="getProfileImageUrl()">
      <span class="header-item username" (click)="usernameClicked()">{{getUsername()}}</span>
      <div #usernameDDContent class="dropdown-content dd-right">
        <span class="menu-item" (click)="accountClicked()">{{getString('account')}}</span>
        <span class="menu-item" (click)="logoutClicked()">{{getString('logout')}}</span>
      </div>
    </div>
    <span *ngIf="!isUserLoggedIn" class="header-separator">|</span>
    <span *ngIf="!isUserLoggedIn" class="header-item" (click)="registerClicked()">{{getString("register")}}</span>
  </div><span class="header-separator">|</span>

  <div *ngIf="isUserLoggedIn" class="dropdown">
    <span class="header-item" (click)="settingsClicked()">{{getString('settings')}}</span>
    <div #settingsDDContent class="dropdown-content dd-right">
      <span class="menu-item" [routerLink]="'/' + getCountry() + '/' + getString('preferencesUrl')" (click)="preferencesClicked()">{{getString('preferences')}}</span>
      <span class="menu-item" [routerLink]="'/' + getCountry() + '/' + getString('notificationsUrl')" (click)="notificationSettingsClicked()">{{getString('notificationSettings')}}</span>
    </div>
  </div>
  <span *ngIf="isUserLoggedIn" class="header-separator">|</span>

  <div class="dropdown">
    <span class="header-item" (click)="moreClicked()">{{getString("more")}}</span> <span class="header-separator">|</span>
    <div #moreDDContent class="dropdown-content dd-right">
      <span class="menu-item" (click)="submitItemClicked()">{{getString("submitMissingItem")}}</span>
      <span class="menu-item" (click)="openBlogInNewTab()">Blog</span>
      <span class="menu-item" (click)="openFAQInNewTab()">FAQ</span>
      <span class="menu-item" [routerLink]="'/' + getCountry() + '/' + getString('imprintUrl')">{{getString("imprint")}}</span>
      <span class="menu-item" [routerLink]="'/' + getCountry() + '/' + getString('privacyPolicyUrl')">{{getString("privacyPolicy")}}</span>
      <span *ngIf="isEU" class="menu-item" (click)="openCookieSettings()">{{getString('cookieSettings')}}</span>
      <span class="menu-item" [routerLink]="'/' + getCountry() + '/' + getString('contactUrl')">{{getString("contact")}}</span>
    </div>
  </div>

  <div class="dropdown">
    <span class="header-item" (click)="storeClicked()">{{getString("store")}}:</span>
    <img alt="" class="header-item country-logo current-country-logo" [src]="currentCountry.icon" (click)="storeClicked()">
    <div #storeDDContent class="dropdown-content dd-right">

      <ng-container *ngFor="let country of countries">
        <a class="menu-item" (click)="selectCountry(country.key)">
          <img alt="" class="country-logo" [src]="country.icon">
          <div class="country-name">{{country.name}}</div>
        </a>
      </ng-container>

      <div class="country-menu-divider"></div>
      <a class="menu-item country-missing-item" [routerLink]="'/' + getCountry() + '/country-poll'" (click)="countryPollClicked()">
        <span class="question-mark-icon">?</span>
        <div class="country-name">{{getString('countryMissing')}}</div>
      </a>

    </div>
    <div class="country-popup" [class.open]="showCountryPopup">{{getCountryChangedText()}}</div>
  </div>

  <span class="header-space"></span>

</div>

<app-authentication #authentication></app-authentication>

<app-modal #changeEmailPasswordModal [title]="getString('changeEmailPassword')">
  <app-change-email-password *ngIf="changeEmailPasswordModal.isOpen" (onAuthFail)="loginClicked()"></app-change-email-password>
</app-modal>

<app-modal #newsModal [title]="getString('newsPage1Title')">
  <p class="txt-algn-cntr">We added new stores to our offspring site CheapCharts Games!</p>
  <div class="link-box">
    <div class="flex-space-around">
      <a class="store-box" target="_blank" href="https://games.cheapcharts.info/us/xbox/games/on-sale">
        <img src="./assets/images/microsoft.png">
        <div>Xbox</div>
      </a>
      <a class="store-box" target="_blank" href="https://games.cheapcharts.info/us/playstation/games/on-sale">
        <img src="./assets/images/playstation.png">
        <div>PlayStation</div>
      </a>
      <a class="store-box" target="_blank" href="https://games.cheapcharts.info/us/nintendo/games/on-sale">
        <img src="./assets/images/nintendo.png">
        <div>Nintendo Switch</div>
      </a>
    </div>

  </div>
  <p>CheapCharts Games is just like CheapCharts as you know it but for video game deals.</p>
  <p>Check it out: <a class="news-link" href="https://games.cheapcharts.info" target="_blank">https://games.cheapcharts.info</a></p>
  <button class="news blue-button" (click)="newsModal.close()">{{getString('awesome')}}</button>
</app-modal>

<app-modal #vuduNewsModal [title]="getString('newsPage1Title')">
  <p class="txt-algn-cntr">Neuigkeiten bei Fandango at Home!</p>
  <div class="link-box">
    <p>Wir haben spannende neue Funktionen und Angebote für Sie vorbereitet.</p>
    <p>Entdecken Sie die besten Fandango at Home Deals und bleiben Sie immer auf dem Laufenden mit unseren Preisänderungen.</p>
  </div>
  <button class="news blue-button" (click)="vuduNewsModal.close()">{{getString('awesome')}}</button>
</app-modal>

<app-modal #accountSettingsModal [title]="getString('account')" [longModal]="true">
  <app-account-settings (onClose)="accountSettingsModal.close()" (onDeleteAccount)="deleteAccountClicked()"></app-account-settings>
</app-modal>

<app-modal #deleteAccountConfirmationModal [title]="getString('deleteAccount')"
[confirmationModal]="true"
[positiveText]="getString('deleteAccount')"
[negativeText]="getString('cancel')"
(onResult)="onDeleteConfirmationResult($event)">
  <p>{{getString('deleteAccountConfirmation')}}</p>
  <p class="red-text">{{deleteAccountError}}</p>
</app-modal>

<app-modal #submitItemModal [title]="getString('submitMissingItem')">
  <!-- Input state -->
  <div *ngIf="!submitItemMessage" style="padding: 0 20px;">
    <p class="txt-algn-cntr">{{getString("submitMissingItemDesc")}}</p>
    <p class="txt-algn-cntr" style="font-size: 12px; color: #888; margin-top: -5px;">{{getString("submitMissingItemNote")}}</p>
    <input type="text" [(ngModel)]="submitItemUrl" [placeholder]="getString('submitMissingItemPlaceholder')"
           style="width: 100%; padding: 12px; border: 1px solid #ccc; border-radius: 5px; font-size: 14px; box-sizing: border-box;"
           (keyup.enter)="submitItem()">
    <div style="display: flex; justify-content: center; gap: 10px; margin-top: 15px; padding-bottom: 10px;">
      <button class="blue-button" (click)="submitItem()" [disabled]="submitItemLoading" style="min-width: 120px;">
        {{submitItemLoading ? "..." : getString("submitMissingItemSubmit")}}
      </button>
      <button (click)="submitItemModal.close()" style="min-width: 120px; padding: 8px 16px; border: 1px solid #00baf7; background: transparent; color: #00baf7; border-radius: 5px; cursor: pointer;">
        {{getString("cancel")}}
      </button>
    </div>
  </div>
  <!-- Result state -->
  <div *ngIf="submitItemMessage" style="padding: 20px 20px 10px; text-align: center; min-height: 180px; display: flex; flex-direction: column; justify-content: center;">
    <div style="margin-bottom: 16px;">
      <span *ngIf="submitItemSuccess" style="display: inline-block; width: 48px; height: 48px; border-radius: 50%; background: #00a03e; line-height: 48px; font-size: 24px; color: #fff;">✓</span>
      <span *ngIf="!submitItemSuccess" style="display: inline-block; width: 48px; height: 48px; border-radius: 50%; background: #f44336; line-height: 48px; font-size: 24px; color: #fff;">✕</span>
    </div>
    <p style="font-size: 15px; margin: 0 0 20px;" [style.color]="submitItemSuccess ? '#00a03e' : '#f44336'">
      {{submitItemMessage}}
    </p>
    <div style="display: flex; justify-content: center; gap: 10px;">
      <a *ngIf="submitItemLink" [href]="submitItemLink" target="_blank"
         style="min-width: 140px; padding: 8px 16px; background: #00baf7; color: #fff; border-radius: 5px; border: 1px solid #00baf7; text-decoration: none; display: inline-block; text-align: center; font-size: 14px; cursor: pointer; box-sizing: border-box;">
        {{getString("submitMissingItemOpenInCC")}}
      </a>
      <button (click)="submitItemMessage = ''; submitItemLink = ''" style="min-width: 140px; padding: 8px 16px; border: 1px solid #00baf7; background: transparent; color: #00baf7; border-radius: 5px; cursor: pointer; font-size: 14px;">
        {{submitItemLink ? getString("submitMissingItemAnother") : getString("submitMissingItemTryAgain")}}
      </button>
    </div>
  </div>
</app-modal>

<app-modal #cookieSettingsModal [showCloseButton]="false" [title]="getString('cookieSettings')">
  <app-cookie-settings *ngIf="cookieSettingsModal.isOpen" [showTitle]="false" (onClose)="applyCookieSettings($event)"></app-cookie-settings>
</app-modal>
